module.exports = __webpack_public_path__ + "img/ico-pay-debt.929da1c6.svg";